import { HttpClient } from '@angular/common/http';

import { TranslateLoader, TranslationObject } from '@ngx-translate/core';

import { catchError, Observable } from 'rxjs';

import { ConfigService } from '@ph-core/services/config/config.service';

import { SupportedLanguageCodes } from 'app/static-data/languages';

import { version } from '../../../../package.json';
import { inject } from '@angular/core';

export class TranslationLoader implements TranslateLoader {
  private httpClient = inject(HttpClient)
  private readonly configService = inject(ConfigService)


  getTranslation(language: string): Observable<TranslationObject> {
    const versionParam = `?version=${version}`;

    return this.httpClient
      .get<TranslationObject>(
        this._getLanguagePath({ application: this.configService.environment.application, language, versionParam })
      )
      .pipe(catchError(() => this.httpClient.get<TranslationObject>(`../../../assets/i18n/en-US.json${versionParam}`)));
  }

  private _getLanguagePath(request: { application: string; language: string; versionParam: string }): string {
    const language = request.language;
    switch (language as SupportedLanguageCodes) {
      case SupportedLanguageCodes.English:
      case SupportedLanguageCodes.EnglishCA:
      default: {
        return `../../../assets/i18n/en-US.json${request.versionParam}`;
      }
      case SupportedLanguageCodes.French: {
        return `../../../assets/i18n/fr-CA.json${request.versionParam}`;
      }
    }
  }
}
